import { FirebaseAppointment } from "../../firestore/types";

export const getPaymentStatusForAppointment = async ({
  appointment,
}: {
  appointment: FirebaseAppointment;
}) => {
  return appointment?.payment?.status;
};
